import { SuperDate } from '@razlet/utils';
import RoutePoint from './point';

export default class RouteStopover extends RoutePoint {
  std = null;
  etd = null;

  sta = null;
  eta = null;

  constructor (data, waitTime = 0, dictionary = {}) {
    super(data, waitTime, 'stopover', dictionary);

    this.std = new SuperDate(data.departureTime);
    if (data.estimatedDepartureTime) this.etd = new SuperDate(data.estimatedDepartureTime);

    this.sta = new SuperDate(data.arrivalTime);
    if (data.estimatedArrivalTime) this.eta = new SuperDate(data.estimatedArrivalTime);
  }
};
